<template>
  <div class="app_container" :class="{ 'list-drag': draggable }">
    <div class="right-user">
      <div class="search">
        <div class="filter_container">
          <butn
            @click="onAdd"
            btntype="primary"
            title="新增"
            v-permission="'region:save'"
            iconName="el-icon-plus"
          ></butn>
          <butn
            title="预览"
            iconName="el-icon-upload"
            @click="onPreview"
          ></butn>
          <!-- v-permission="'part:preview'" -->
          <el-checkbox
            :value="draggable"
            @change="onCheck"
            :disabled="!canDraggable"
            class="drag-box m-l-14"
            v-permission="'region:drag'"
            >拖拽排序</el-checkbox
          >
        </div>
        <Search @search="onSearch" />
      </div>
      <Table
        :data="partList"
        row-key="uuid"
        @selection-change="selectChange"
        @delete="onDelete"
        @edit="onEdit"
        @line="onLine"
      />
      <div class="RCPagination">
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        />
      </div>
    </div>

    <el-dialog
      title="App配置效果预览"
      width="500px"
      lock-scroll
      :visible.sync="showPreview"
      custom-class="custom-preview-dialog"
    >
      <PartConfig :showPreview="showPreview" />
    </el-dialog>
  </div>
</template>

<script>
import Table from "./table.js";
import Search from "./search";
import butn from "@/components/button/index";
import PartConfig from "./preview";

import Sortable from "sortablejs";

import {
  queryPartListByKey,
  deletePart,
  upPart,
  updatePartOrder,
} from "@/pages/part/api";
import { getItem, removeItem } from "@/utils/storage.js";

export default {
  name: "part",
  activated() {
    if (getItem(this.REFRESH_FLAG)) {
      this.getPartListByKey();
      removeItem(this.REFRESH_FLAG);
    }
  },

  components: {
    Table,
    Search,
    butn,
    PartConfig: PartConfig,
  },

  data() {
    return {
      userLists: [],
      deptList: [],
      api: queryPartListByKey,
      checkArray: [],
      dataname: "",
      currentDepId: "",
      dept: {},
      drag: true,
      draggable: false,
      partList: [],
      currentPage: 1,
      size: 10,
      total: 0,
      canDraggable: true,
      showPreview: false,
    };
  },
  created() {
    this.getPartListByKey();
  },
  methods: {
    // 接口请求
    getPartListByKey() {
      const params = {
        ...this.dataname,
        page: this.currentPage || 1,
        limit: this.size || 10,
      };
      queryPartListByKey(params)
        .then((res) => {
          let partList = [];
          if (res.records && res.records.length) {
            partList = res.records;
          }
          this.total = res.total;
          this.partList = partList;
        })
        .catch((_) => _);
    },

    // 删除
    deletePart(data) {
      deletePart(data)
        .then((res) => {
          res.msg && this.success(res.msg);
          this.getPartListByKey();
        })
        .catch((_) => _);
    },

    // 上下线
    upPart(data) {
      upPart(data)
        .then((res) => {
          res.msg && this.success(res.msg);
          this.getPartListByKey();
        })
        .catch((_) => _);
    },

    // 拖拽
    updatePartOrder(data) {
      updatePartOrder(data)
        .then((res) => {
          if (res.code === 0) {
            res.msg && this.success(res.msg);
          }
          this.getPartListByKey();
        })
        .catch((_) => _);
    },

    success(msg) {
      msg &&
        this.$message({
          type: "success",
          message: msg,
        });
    },

    onSearch(param = {}) {
      this.canDraggable = !!param.canDraggable;
      if (!this.canDraggable) {
        this.draggable = false;
      }
      delete param.canDraggable;
      this.dataname = param;
      this.getPartListByKey();
    },

    onDelete(row, idx) {
      const data = {
        uuids: [row.uuid],
      };
      this.deletePart(data);
    },

    onEdit(row, idx) {
      this.$router.push({
        path: "/part/add",
        query: {
          id: row.uuid,
        },
      });
    },

    onLine(row, idx) {
      const data = {
        uuid: row.uuid,
      };
      this.upPart(data);
    },

    onAdd() {
      this.$router.push({
        path: "/part/add",
      });
    },

    selectChange(selections) {
      this.checkArray = selections;
    },

    onCheck(draggable) {
      this.draggable = draggable;
      this.toggleDrag(draggable);
    },

    sizeChange(size) {
      this.size = size;
      this.getPartListByKey();
    },

    pageChange(page) {
      this.currentPage = page;
      this.getPartListByKey();
    },

    toggleDrag(draggable) {
      const vm = this;
      if (!draggable) {
        // 关闭拖拽功能时销毁Sortable对象
        vm.sort && this.sort.destroy();
      } else {
        const that = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        vm.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          // 开始拖拽的时候
          onEnd({ oldIndex, newIndex, ...rest }) {
            // { oldIndex, newIndex }
            if (oldIndex === newIndex) return;

            const data = {
              uuid: vm.partList[oldIndex].uuid,
              offset: newIndex - oldIndex,
            };
            vm.updatePartOrder(data);
            vm.partList = [];
          },
        });
      }
    },

    onPreview() {
      this.showPreview = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.app_container {
  display: flex;
  flex-direction: column;
}
.filter_container {
  padding-bottom: 24px;
  display: flex;
  align-items: center;
}
.left-dept {
  width: 206px;
  background-color: #f4f8fb;
  padding: 24px 10px;
  box-sizing: border-box;
  /deep/ .el-tree-node__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.right-user {
  padding: 0 0 0 10px;
  box-sizing: border-box;
  overflow-y: auto;
  flex: 1;
}
.search {
  display: flex;
}
.search .filter_container {
  margin-right: auto;
}
.deal-group {
  cursor: pointer;
}
.dropdown {
  margin-right: 10px;
}
.right-bin {
  flex: 1;
  text-align: right;
}
</style>

<style lang="scss">
.custom-preview-dialog {
  overflow-y: hidden;
  .el-dialog__body {
    max-height: 690px;
  }
}
</style>